import styled from 'styled-components';

import { ThemeProp } from '../../../../../../../../theme/Themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 1.5rem 2rem 1.5rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: 0 1.5rem 2rem 1.5rem;
  }
`;
